import { Modal } from 'antd';
import { MessageInstance } from 'antd/es/message/interface';
import { useTranslation } from 'react-i18next';
import MatchOrderForm from './MatchOrderForm';

interface MatchOrderProps {
  pendingOrderIds?: Parameters<typeof MatchOrderForm>[0]['pendingOrderIds'];
  visible: boolean;
  study: Parameters<typeof MatchOrderForm>[0]['study'];
  onCancel: Parameters<typeof MatchOrderForm>[0]['onCancel'];
  message: MessageInstance;
}

const MatchOrder = ({ pendingOrderIds, visible, study, onCancel, message }: MatchOrderProps) => {
  const { t } = useTranslation('Vindoc');

  return (
    <Modal
      className="vindr-modal add-order max-w-screen w-[900px]"
      title={t('Match Order')}
      open={visible}
      maskClosable={false}
      destroyOnClose
      zIndex={1001}
      onCancel={onCancel}
      footer={null}
    >
      <MatchOrderForm
        pendingOrderIds={pendingOrderIds}
        study={study}
        onFinish={onCancel}
        onCancel={onCancel}
        message={message}
      />
    </Modal>
  );
};

export default MatchOrder;
